{
  "modal": {
    "title": "Reservera",
    "recurringReservation": "Regelbunden tur",
    "singleReservation": "Enskild tur",
    "saunaRulesLink": "Regler",
    "commonAreaRulesLink": "Regler",
    "commonAreaTermsLink": "Reservationsvillkor",
    "acceptRules": "Jag accepterar regler och reservationsvillkor",
    "cancel": "Avbryt",
    "confirm": "Bekräfta",
    "reserveButton": "Boka",
    "paymentButton": "Betala",
    "reservationLimitWarning": "Du har nått det maximala antalet bokningar. Om du vill byta tid, avboka först din nuvarande bokning.",
    "sendConfirmationEmail": "Skicka bekräftelsemeddelande till min e-post",
    "confirmationEmailOffWarningFree": "Du hittar reservationsinformation på boendesidorna.",
    "confirmationEmailOffWarningPaid": "Du hittar reservationsinformation på boendesidorna. Betalningsbekräftelse skickas alltid till e-post."
  },
  "success": {
    "title": "Reservation lyckades!"
  },
  "payment": {
    "succeeded": "Betalningen för reservationen lyckades!",
    "failed": "Betalningen för reservationen misslyckades!",
    "failedMessage": "Försök igen eller kontakta kundtjänst.",
    "singleReservation": "Enskild reservation"
  },
  "error": {
    "reservationFailed": "Reservationen misslyckades. Försök igen om en stund.",
    "overlap": "Den valda reservationen står i konflikt med en befintlig reservation. Välj en annan tid eller avboka den nuvarande.",
    "contractEndDate": "Reservationens tidpunkt får inte vara efter avtalets slutdatum.",
    "contractEndDateStart": "Reservationen kan inte börja efter avtalets slutdatum.",
    "contractEndBeforeReservationStart": "Avtalets slutdatum är före den valda reservationens start.",
    "reservationEndBeforeStart": "Reservationens slutdatum måste vara samma som eller senare än startdatumet.",
    "reservationStartBeforeContractStart": "Reservationen kan inte börja före avtalets startdatum.",
    "contractContinuousNotAllowed": "En tidsobestämd reservation kan inte göras för ett avtal som har ett slutdatum.",
    "maxReservedSlotsPerWeek": "Avtalets veckovisa bokningsgräns har överskridits.",
    "invalidSlotGridPosition": "Reservationsplatserna är inte på giltiga tider.",
    "conflict": "Reservationen kunde inte göras för den valda tiden. Välj en annan tid eller kontakta kundtjänst.",
    "slotAlreadyStarted": "Det går inte att boka en tid som redan har börjat.",
    "commonError": "Ett fel inträffade, försök igen senare.",
    "reloadButton": "Ladda om"
  },
  "cancelModal": {
    "title": "Reservationsdetaljer",
    "recurringWarning": "Detta är en återkommande reservation. Att avboka denna reservation kommer också att avboka alla framtida reservationer i serien.",
    "terminateWarning": "Om du avslutar reservationen tas alla reservationer från och med detta datum bort.",
    "effectiveFrom": "Ändringen träder i kraft: {{date}}",
    "recurringInfo": "Återkommande {{weekday}} kl. {{timeRange}}, från {{date}}",
    "singleNotAllowed": "Du kan inte avboka denna reservation. Kontakta kundtjänst.",
    "sameDayNotAllowed": "Du kan inte avboka en reservation samma dag",
    "terminateSameDayNotAllowed": "En återkommande reservation kan inte avslutas samma dag.",
    "cancelFailed": "Avbokningen misslyckades. Försök igen senare.",
    "recurringCancelNotAllowed": "En återkommande reservation kan inte avbokas efter att den redan har startat.",
    "notAllowed": "Inte tillåtet",
    "cancel": "Avbryt",
    "confirmSingle": "Avboka reservation",
    "confirmRecurring": "Avboka reservationer",
    "confirmTerminate": "Avsluta reservation",
    "successSingle": "Reservation avbokad",
    "successRecurring": "Reservationer avbokade",
    "successTerminated": "Reservation avslutad",
    "contractTerminated": "Reservationen kan inte avbokas eller avslutas eftersom avtalet har avslutats.",
    "reservationTitle": "Reservationsdetaljer"
  },
  "legend": {
    "freeSlot": "Ledig tur",
    "reservedSlot": "Reserverad tur",
    "ownReservation": "Egen reservation",
    "ownSingleReservation": "Egen enskild reservation"
  },
  "timeFormatting": {
    "everyWeek": "varje vecka",
    "atTime": "kl",
    "weekdayWithTimeRange": "{{weekday}} kl {{timeRange}}",
    "weekdayDateWithTimeRange": "{{weekday}} {{date}} kl {{timeRange}}",
    "dateWithTimeRange": "{{date}} kl {{timeRange}}",
    "startingFrom": "från och med",
    "beginningFrom": "Från och med:",
    "priceAddedToContract": "läggs till ditt kontrakt",
    "recurringType": "Regelbunden tur",
    "singleType": "Enskild tur",
    "recurringCancelled": "Regelbunden tur avbokad",
    "recurringTerminated": "Regelbunden tur avslutad",
    "singleCancelled": "Enskild tur avbokad",
    "hasCancelled": "har avbokats",
    "hasTerminated": "har avslutats",
    "recurringUnitPrice": "Pris {{price}}€/st/månad",
    "singleUnitPrice": "Pris {{price}}€/bokning",
    "upcomingRecurringUnitPrice": "Nytt pris {{price}}€/st/månad från och med {{date}}.",
    "priceAddedToContractFromDate": "läggs till ditt kontrakt från och med {{date}}.",
    "payOn3rdParty": "betalas via extern tjänst"
  },
  "weekdays": {
    "monday": "Mån",
    "tuesday": "Tis",
    "wednesday": "Ons",
    "thursday": "Tor",
    "friday": "Fre",
    "saturday": "Lör",
    "sunday": "Sön"
  },
  "equipmentCategories": {
    "washing_machine": "Tvättmaskin",
    "allergy_washing_machine": "Allergitvättmaskin",
    "dryer": "Torktumlare",
    "mangle": "Mangel"
  },
  "filters": {
    "allEquipment": "All utrustning",
    "laundryRoom": "Tvättrum",
    "washingMachines": "Tvättmaskiner",
    "dryers": "Torktumlare",
    "allSaunas": "Alla bastur",
    "sauna": "Bastur",
    "mangles": "Manglar"
  },
  "myReservations": "Mina reservationer",
  "pageTitle": "Tvättreservationer",
  "pageTitleSauna": "Bastuturer",
  "pageTitleGym": "Gymbokningar",
  "pageTitleCommonAreas": "Samlingslokaler",
  "commonAreaSidebarDescription": "Här kan du se samlingslokalsreservationer och boka din egen genom att välja en ledig tid",
  "noCalendarsAvailable": "Inga reservationskalendrar tillgängliga för den valda veckan",
  "noReservableEquipment": "Ingen reserverbar utrustning",
  "saunaSidebarDescription": "Här kan du se bastuturer och boka din egen genom att välja en ledig tid eller trycka på Boka",
  "gymSidebarDescription": "Här kan du se gymturer och boka din egen genom att välja en ledig tid",
  "pincode": "PIN-kod: {{pincode}}",
  "loadingPincode": "Laddar PIN-kod...",
  "pincodeLoadError": "Misslyckades att ladda PIN-kod"
}
